export interface VzlaBank {
  code: string;
  name: string;
  rif: string | null;
}

export const VZLA_BANKS: VzlaBank[] = [
  { code: '0102', name: 'Banco de Venezuela S.A.C.A. Banco Universal', rif: 'G200099976' },
  { code: '0104', name: 'Venezolano de Crédito, S.A. Banco Universal', rif: 'J000029709' },
  { code: '0105', name: 'Mercantil Banco, C.A. Banco Universal', rif: 'J000029610' },
  { code: '0108', name: 'BBVA Provincial, S.A. Banco Universal', rif: 'J000029679' },
  { code: '0114', name: 'Bancaribe C.A. Banco Universal', rif: 'J000029490' },
  { code: '0115', name: 'Banco Exterior C.A. Banco Universal', rif: 'J000029504' },
  { code: '0128', name: 'Banco Caroní C.A. Banco Universal', rif: 'J095048551' },
  { code: '0134', name: 'Banesco, Banco Universal S.A.C.A.', rif: 'J070133805' },
  { code: '0137', name: 'Banco Sofitasa, Banco Universal', rif: 'J090283846' },
  { code: '0138', name: 'Banco Plaza, Banco Universal', rif: 'J002970553' },
  { code: '0146', name: 'Bangente C.A', rif: 'J301442040' },
  { code: '0151', name: 'BFC Banco Fondo Común C.A. Banco Universal', rif: 'J000723060' },
  { code: '0156', name: '100% Banco, Banco Universal C.A.', rif: 'J085007768' },
  { code: '0157', name: 'DelSur Banco Universal C.A.', rif: 'J000797234' },
  { code: '0163', name: 'Banco del Tesoro, C.A. Banco Universal', rif: 'G200051876' },
  { code: '0166', name: 'Banco Agrícola de Venezuela, C.A. Banco Universal', rif: 'G200057955' },
  { code: '0168', name: 'Bancrecer, S.A. Banco Microfinanciero', rif: 'J316374173' },
  { code: '0169', name: 'R4, Banco Microfinanciero C.A.', rif: 'J315941023' },
  { code: '0171', name: 'Banco Activo, Banco Universal', rif: 'J080066227' },
  { code: '0172', name: 'Bancamiga, Banco Universal C.A.', rif: 'J316287599' },
  { code: '0173', name: 'Banco Internacional de Desarrollo, C.A. Banco Universal', rif: 'J294640109' },
  { code: '0174', name: 'Banplus Banco Universal, C.A', rif: 'J000423032' },
  { code: '0175', name: 'Banco Digital de Los Trabajadores', rif: 'G200091487' },
  { code: '0177', name: 'Banco de la Fuerza Armada Nacional Bolivariana, B.U.', rif: 'G200106573' },
  { code: '0178', name: 'N58 Banco Digital, S.A.', rif: 'J503581107' },
  { code: '0191', name: 'Banco Nacional de Crédito, C.A. Banco Universal', rif: 'J309841327' },
  { code: '0601', name: 'Instituto Municipal de Crédito Popular', rif: null },
];

const codeToBank = new Map<string, VzlaBank>(VZLA_BANKS.map((b) => [b.code, b]));

function normalizeCode(value: string): string[] {
  const s = value.replace(/\s/g, '');
  const candidates: string[] = [s];
  if (s.length > 4) {
    candidates.push(s.slice(0, 4));
  }
  if (s.length < 4 && /^\d+$/.test(s)) {
    candidates.push(s.padStart(4, '0'));
  }
  if (/^\d+$/.test(s) && s.length <= 4) {
    candidates.push(s.padStart(4, '0'));
  }
  return [...new Set(candidates)];
}

/**
 * Devuelve el nombre del banco para mostrar.
 * Acepta código de 4 dígitos ("0105"), 5 dígitos ("01015" → usa "0105") o número sin ceros.
 * Si no hay coincidencia, devuelve el valor original.
 */
export function getBankDisplayName(codeOrName: string | null | undefined): string {
  if (codeOrName == null || String(codeOrName).trim() === '') return '-';
  const s = String(codeOrName).trim();
  const byCode = codeToBank.get(s);
  if (byCode) return byCode.name;
  for (const candidate of normalizeCode(s)) {
    const found = codeToBank.get(candidate);
    if (found) return found.name;
  }
  return s;
}
